'use strict';

window.FoG = window.FoG || {};

window.FoG.Carousel = (function($) {
  var transitionMs = 900;
  
  function populateCarousel($carousel, idx) {
    var $articles = $carousel.data('$carousel-contents').find('li > article');
    var numArticles = $articles.length;
    
    if (!numArticles) { return; }
    
    while (idx < 0) { idx += numArticles; }
    
    var $display = $carousel.data('$carousel-display');
    $carousel.data('carousel-selectedIdx', idx);

    $display.empty();
    
    for (var i = 0; i < 4; i++) {
      var articleIdx = (idx++) % numArticles;
      var $article = $($articles[articleIdx]).clone();
      $display.append($article);
    }
  }
  
  function getClosest$Carousel(selector) {
    return $(selector).closest('.postCarousel');
  }

  function movePrev() {
    slideTransition(this, -1);
  }
  
  function moveNext() {
    slideTransition(this, 1);
  }
  
  function slideTransition(el, direction) {
    direction = (direction > 0) ? 1 : -1;
    var transitionStyle = direction > 0 ? 'carousel--slidingRight' : 'carousel--slidingLeft';
    var $carousel = getClosest$Carousel(el);
    
    // Don't allow further clicks until the transition is complete 
    if ($carousel.hasClass('carousel--sliding')) { return; }
    
    var idx = ($carousel.data('idx') || 0) + direction;
    $carousel.data('idx', idx);
    
    $carousel.addClass(transitionStyle).addClass('carousel--sliding');

    // Disable more clicks until after the transition
    window.setTimeout(() => {
      populateCarousel($carousel, idx);
      $carousel.removeClass(transitionStyle).removeClass('carousel--sliding');
    }, transitionMs);
  }
  
  function setUpCarousel(selector) {
    var $carousel = $(selector);
    var $contents = $carousel.find('ul[data-carousel-contents]').detach();
    
    $carousel.data('$carousel-contents', $contents);
    $carousel.data('$carousel-display', $carousel.find('div[data-carousel-display]'));
    
    $carousel.find('.btn--prev').on('click', movePrev);
    $carousel.find('.btn--next').on('click', moveNext);
    
    $contents.hide();
    populateCarousel($carousel, 0);
  }
  
  function init() {
    $('section.carousel .postCarousel').each((idx, el) => setUpCarousel(el));
  }
  
  $(init);
  
  return {};
})(jQuery);